<template>
	<div class="contents">
		<headerTop></headerTop>
		<div class="swiperImg" :style="{backgroundImage:'url('+$index.addurl(img)+')'}"></div>
		<!-- 办公环境 -->
		<div class="center page-content" :style="{animation:animation}">
			<div class="headers">
				<div class="type flexleft" ref="type" >
					<div class="title">类别</div>
					<div :class="typeStatus==1?'hidden':''">
						<div class="typeList flexleft" >
							<div :class="typeCurrent==-1?'childs':'child'" @click="typeAll">全部</div>
							<div :class="index==typeCurrent?'childs':'child'" v-for="(item,index) in typeList" @click="typeChange(index)">{{item}}</div>
						</div>
						<div class="more" v-if="typeStatus==1" @click="typeStatus=2">更多</div>
						<div class="pack" v-if="typeStatus==2" @click="typeStatus=1">收起</div>
					</div>
				</div>
				<div class="type flexleft" ref="tag">
					<div class="title">标签</div>
					<div :class="tagStatus==1?'hidden':''">
						<div class="typeList flexleft" >
							<div :class="tagCurrent==-1?'childs':'child'" @click="tagAll">全部</div>
							<div :class="index==tagCurrent?'childs':'child'" v-for="(item,index) in tagList" @click="tagChange(index)">{{item.name}}</div>
						</div>
						<div class="more" v-if="tagStatus==1" @click="tagStatus=2">更多</div>
						<div class="pack" v-if="tagStatus==2" @click="tagStatus=1">收起</div>
					</div>
				</div>
			</div>
			<div class="videoList flexleft">
				<div class="child flexbetween" v-for="(item,index) in list" :key="index">
					<div class="left">
						<div class="endetime flexleft">
							<div class="colorLv" v-if="item.endtime<=timestamp"></div>
							<div class="colorRed" v-if="item.endtime>timestamp"></div>
							<div class="txt">{{item.endtime*1000 > timestamp && timestamp > item.starttime*1000 ? '正在进行': timestamp > item.endtime*1000 ? '已结束' :'未开始'}}&nbsp;{{item.start}}-{{item.end}}</div>
						</div>
						<img :src="$index.addurl(item.thum)" alt="">
					</div>
					<div class="right">
						<div class="right_title">{{item.title}}</div>
						<div class="times flexleft">
							<div class="time">{{item.start}}-{{item.end}}</div>
							<div class="type">{{item.type==1?'线上':item.type==2?'线下':'线上+线下'}}</div>
						</div>
						<div class="contentss">{{item.info}}</div>
						<div class="address flexleft">
							<div class="addImg">
								<img src="../../assets/image/dingwei.png" alt=""  v-if="item.type==2">
								<img src="../../assets/image/diannao.png" alt="" v-if="item.type==1">
							</div>
							<div class="txt flexleft">
								<div class="addressTxt"  v-if="item.type==2">地址：{{item.offline_address}}</div>
							</div>
						</div>
						<div class="flexright">
							<div class="ljmore"  @click.stop="todetail(item.id)">了解更多</div>
						</div>
					</div>
				</div>
			</div>
			<div class="page">
				<el-pagination
				:hide-on-single-page="value"
				:current-page="currentPage"
				  :page-size="10"
				  @current-change = "addPage"
				  layout="prev, pager, next"
				  :total="total">
				</el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
	import router from "../../router";
	import headerTop from '../../components/headerTop.vue'
	export default{
		components: {
			headerTop
		},
		data(){
			return {
				typeList:[],
				tagList:[],
				id:0,
				contents:'',
				value:true,  //分页只有一页时隐藏分页
				currentPage:1, //分页当前页数
				total:0,
				img:'',
				animation:'',
				serList:[],
				typeCurrent:-1,
				tagCurrent:-1,
				typeStatus:0,
				tagStatus:0,
				newOre:0,
				typeId:'',
				tagId:'',
				list:[],
				timestamp:'',  //当前时间戳
			}
		},
		created() {
			this.animation = 'detail .4s linear forwards'
			this.getchangeList();
			this.timestamp = new Date().getTime(); 
		},
		mounted() {
			if(this.$refs.type.offsetHeight>100){
				this.typeStatus = 1;
			}
			if(this.$refs.tag.offsetHeight>100){
				this.tagStatus = 1;
			}
		},
		methods:{
			timestampToTime(timestamp) {				 var date = new Date(timestamp * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000				 var Y = date.getFullYear() + '-';				 var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1):date.getMonth()+1) + '-';				 var D = (date.getDate()< 10 ? '0'+date.getDate():date.getDate())+ ' ';				 var h = (date.getHours() < 10 ? '0'+date.getHours():date.getHours())+ ':';				 var m = (date.getMinutes() < 10 ? '0'+date.getMinutes():date.getMinutes()) ;				 var s = date.getSeconds() < 10 ? '0'+date.getSeconds():date.getSeconds();				 return Y+M+D+h+m;			   },
			getlist(){
				let _this = this;
				_this.$api.user.getCjhdList({
					type:_this.typeId,
					special:_this.tagId,
					page:_this.currentPage,
				}).then(res => {
					if(res.code == 1){
						res.data.list.data.forEach(item => {
							_this.$set(item,'end','');
							_this.$set(item,'start','');
							item.end = _this.timestampToTime(item.endtime);
							item.start = _this.timestampToTime(item.starttime);
						})
						_this.list = res.data.list.data;
						_this.total = res.data.list.total;
						_this.currentPage = res.data.list.current_page;
						_this.img = res.data.background_img;
					}
				})
			},
			typeAll(){
				this.typeId = '';
				this.typeCurrent = -1;
				this.currentPage = 1;
				this.getlist();
			},
			tagAll(){
				this.tagId = '';
				this.tagCurrent = -1;
				this.currentPage = 1;
				this.getlist();
			},
			getchangeList(){
				let _this = this;
				_this.$api.user.getCjhdFilter({
				}).then(res => {
					if(res.code == 1){
						_this.typeList = res.data.type;
						_this.tagList = res.data.special;
						this.getlist();
					}
				})
			},
			todetail(id){
				const { href } = this.$router.resolve({
					name: 'joinActivitydetail',
					query: {id:id,}
				  });
				  window.open(href, '_blank');
			},
			addPage(e){
				this.currentPage = e;
				this.getlist();
			},
			changeNew(){
				this.newOre = 0;
			},
			changeRe(){
				this.newOre = 1;
			},
			typeChange(index){
				let _this = this;
				_this.typeCurrent = index;
				_this.typeId = index;
				_this.currentPage = 1;
				_this.getlist();
			},
			tagChange(index){
				let _this = this;
				_this.tagCurrent = index;
				_this.tagId = _this.tagList[index].id;
				_this.currentPage = 1;
				_this.getlist();
			},
		},
		
	}
</script>
<style scoped>
	.contents{
		background-color: #1452DC;
		border-bottom: 1px solid #1452DC;
	}
</style>
<style scoped lang="scss">
	.hidden{
		height: 54px;
		overflow: hidden;
	}
	.swiperImg{
		background-image: url('../../assets/page4/bg1.png');
		background-size: cover;
		background-position: center;
		position: relative;
		padding: 250px 0;
		.lTitle{
			margin-left: 4vw;
			font-size: 30px;
			letter-spacing: 4px;
			color: #fff;
		}
		.bTitle{
			margin-left: 4vw;
			color: #fff;
			font-size: 58px;
			letter-spacing: 4px;
			font-weight: bold;
		}
		.sTitle{
			margin-left: 4vw;
			letter-spacing: 2px;
			font-size: 14px;
			color: #fff;
		}
	}
	.page{
		margin: 10px auto;
		display: flex;
		justify-content: center;
	}
	.center{
		min-height: 300px;
		width: 1400px;
		margin: 0 auto;
		background-color: #fff;
		padding: 80px 100px 60px;
		border-radius: 30px;
		position: relative;
		top: -80px;
		.videoList{
			flex-wrap: wrap;
			width: 1200px;
			.child{
				width: 100%;
				border-top: 20px solid #F3F4F8;
				padding: 30px;
				.left{
					width: 600px;
					height: 320px;
					margin-right: 50px;
					position: relative;
					img{
						object-fit: fill;
						width: 600px;
						height: 320px;
					}
					.endetime{
						position: absolute;
						top: 10px;
						left: 10px;
						background-color: rgba(0, 0, 0, 0.5);
						padding: 10px;
						border-radius: 4px;
						.colorLv{
							width: 10px;
							height: 10px;
							border-radius: 50%;
							background-color: #04FD8A;
						}
						.colorRed{
							width: 12px;
							height: 12px; 
							border-radius: 50%;
							background-color: #ff0000;
						}
						.txt{
							margin-left: 6px;
							font-size: 14px;
						}
					}
				}
				.right{
					align-self: flex-start;
					flex-grow: 1;
					position: relative;
					.times{
						.type{
							margin-left: 10px;
							font-size: 18px;
						}
						.time{
							color: #333;
							font-size: 18px;
							margin: 10px 0;
						}
					}
					.right_title{
						font-weight: bold;
						font-size: 24px;
						color: #333;
					}
					.contentss{
						color: #333;
						font-size: 16px;
						margin: 20px 0 10px;
						min-height: 100px;
						display: -webkit-box;
						overflow: hidden;
						/*! autoprefixer: off; */
						-webkit-box-orient: vertical;
						-webkit-line-clamp: 4;
					}
					.address{
						margin-bottom: 10px;
						.addImg{
							width: 24px;
							height: 24px;
							margin-right: 10px;
							img{
								width: 100%;
								height: 100%;
							}
						}
						.txt{
							color: #ABAAB5;
							font-size: 18px;
						}
					}
					.ljmore{
						width: 120px;
						text-align: center;
						padding: 10px 0;
						font-size: 16px;
						color: #fff;
						background-color: #1452DC;
						cursor: pointer;
					}
				}
			}
		}
		.rank{
			margin: 10px 0;
			font-size: 14px;
			color: #333;
			padding: 0 30px;
			.new{
				cursor: pointer;
			}
			.news{
				cursor: pointer;
				color: #1452DC;
			}
			.res{
				color: #1452DC;
				cursor: pointer;
			}
			.re{
				cursor: pointer;
			}
			.line{
				margin: 0 30px;
			}
		}
		.headers{
			.type{
				padding: 12px 0;
				position: relative;
				.more{
					position: absolute;
					right: 0px;
					top: 22px;
					font-size: 14px;
					cursor: pointer;
				}
				.pack{
					position: absolute;
					right: 0px;
					bottom: 32px;
					font-size: 14px;
					cursor: pointer;
				}
				.title{
					color: #000;
					font-size: 14px;
					width: 100px;
					line-height: 44px;
					text-align: center;
					align-self: flex-start;
				}
				.typeList{
					flex-wrap: wrap;
					max-width: 1030px;
					.child{
						color: #333;
						font-size: 14px;
						padding: 10px 20px;
						width: fit-content;
						text-align: center;
						cursor: pointer;
						margin-bottom: 10px;
					}
					.childs{
						cursor: pointer;
						color: #1452DC;
						background-color: rgba(207, 232, 252, 0.5);
						font-size: 14px;
						padding: 10px 20px;
						width: fit-content;
						text-align: center;
						margin-bottom: 10px;
					}
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// joinActivity.vue?c891102c